module.exports = __webpack_public_path__ + "img/paysage-drone.25fd2262.jpg";